import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { useAuthUser } from '../../api';
import { useSuspenseFeatureAccess } from '../../api/hooks/workspace/useSuspenseFeatureAccess';
import { useUpdateWorkspace } from '../../api/hooks/workspace/useUpdateWorkspace';
import { EmptyState } from '../EmptyState';
import { QualityGovernanceFilters } from './GovernanceFilters/QualityGovernanceFilters';
import { UpgradeButton } from './UpgradeButton';

export function QualityScoreSettings() {
	const { workspace } = useAuthUser();
	const { mutateAsync: updateWorkspace } = useUpdateWorkspace(workspace.id);

	const { dqsAccess } = useSuspenseFeatureAccess();

	if (!dqsAccess) {
		return (
			<EmptyState
				title="Upgrade to access Quality Score"
				description="You can use the Data Quality Score to understand and improve your data quality."
				illustrationName="upgrade"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
				withActions={<UpgradeButton feature="DQS" size="md" />}
			/>
		);
	}

	return (
		<Stack spacing={0}>
			<Box mb="4xl">
				<SettingsSwitch
					onChange={(checked) =>
						updateWorkspace({
							data: { id: workspace.id, quality_enabled: checked },
						})
					}
					checked={workspace?.quality_enabled ?? false}
					title="Data Quality Score"
					description="Turn on Data Quality Score (DQS) for all tables"
				/>
			</Box>
			{workspace?.quality_enabled && <QualityGovernanceFilters />}
		</Stack>
	);
}
